import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { LOGIN_PATH, FORGOTTEN_PASSWORD_PATH } from '../config/routes'
import config from '../config/config'
import { setFlashMessage } from '../contexts/WebsiteContext'
import PageHeroTitle from '../components/PageHeroTitle'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'

const ForgottenPasswordRequest = () => {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')

  const handleSendResetLink = async (e) => {
    e.preventDefault()
    try {
      const resetPasswordPath = `${window.location.origin}${FORGOTTEN_PASSWORD_PATH}`

      const response = await fetch(
        `${config.apiUrl}user/forgotten-password-request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, resetPasswordPath }),
        },
      )

      if (response.ok) {
        setFlashMessage(
          t('FORGOTTEN_PASSWORD_REQUEST_SUCCESS_MESSAGE'),
          'success',
        )
      } else {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t('FORGOTTEN_PASSWORD_REQUEST_TITLE')}
        description=""
      />

      <div
        className="block-wrapper mt-4"
        style={{ maxWidth: '600px', margin: 'auto' }}
      >
        <p>{t('FORGOTTEN_PASSWORD_REQUEST_DESCRIPTION')}</p>

        <Form onSubmit={handleSendResetLink} style={{ marginBottom: '60px' }}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>{t('LOGIN_EMAIL')}</Form.Label>
            <Form.Control
              type="email"
              placeholder={t('LOGIN_EMAIL_PLACEHOLDER')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <div className="text-center m-3">
            <Button variant="primary" type="submit">
              {t('SEND')}
            </Button>
          </div>

          <div className="text-center">
            <Link to={LOGIN_PATH} className="forgot-password-link">
              {t('LOGIN_LOGIN')}
            </Link>
          </div>
        </Form>
      </div>

      <Footer />
    </div>
  )
}

export default ForgottenPasswordRequest
